import React from 'react'
import classNames from 'classnames'

import { Container } from '@scentregroup/ui'
import { AngleBackground, AngleType } from '../angle-background'
import style from './index.module.scss'

export const MarketplaceAngleContainer: React.FC<{
  children: React.ReactNode
  padded?: boolean
  inverted?: boolean
  hideAngle?: boolean
}> = ({ children, padded = true, inverted = false, hideAngle = false }) => (
  <div className={style.MarketplaceAngleContainer}>
    {!hideAngle && (
      <AngleBackground
        className={classNames(style.background, { [style.inverted]: inverted })}
        angleType={AngleType.topLeft}
      />
    )}
    <Container
      type="large"
      className={classNames(style.container, {
        [style.padded]: padded,
      })}
    >
      {children}
    </Container>
  </div>
)
